import React, { useState, useEffect, useRef, useCallback } from "react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddCompleteSetIcon from '../../icons/AddCompleteSetIcon';
import CloseIcon from '../../icons/CloseIcon';
import DoneIcon from '../../icons/DoneIcon';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from '@material-ui/core/Paper';
import CardActionArea from '@material-ui/core/CardActionArea';
import XLSX from "xlsx";
import axios from 'axios';
import translate from '../../other/translate.json';
import config from '../../other/config';
export default function DropZone() {
  const lang = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [validFiles, setValidFiles] = useState([]);
  const [unsupportedFiles, setUnsupportedFiles] = useState([]);
  const fileInputRef = useRef();
  const [isReading, setIsReading] = useState(false);
  const [mobileView, _mobileView] = useState(window.innerWidth < 380 ? true : false);
  const { serverAPI } = config;

  useEffect(() => {
    let filteredArray = selectedFiles.reduce((file, current) => {
      const x = file.find(item => item.name === current.name);
      if (!x) {
        return file.concat([current]);
      } else {
        return file;
      }
    }, []);
    setValidFiles([...filteredArray]);

  }, [selectedFiles]);

  function dragOver(e) {
    e.preventDefault();
  }

  function dragEnter(e) {
    e.preventDefault();
  }

  const handleFileChange = useCallback((e) => {
    let ids = [], products = [], services = [];
    let response = [];
    const file = e;
    var reader = new FileReader();
    reader.onload = async function (e) {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: "array" });
      const hasSS = workbook.SheetNames.includes('Modern Systems')//.length === 4;
      var firstSheet = workbook.SheetNames[0];
      const secondSheet = workbook.SheetNames[hasSS ? 2 : 1];
      const thirdSheet = workbook.SheetNames[hasSS ? 3 : 2];

      const ssSheet = workbook.SheetNames[1];
      console.log(workbook.SheetNames, workbook)

      const elements = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);

      for (let i = 0; i < elements.length; i++) {
        ids.push(Object.values(elements[i])[4])
      }
      if (hasSS) {
        const elementsSS = XLSX.utils.sheet_to_json(workbook.Sheets[ssSheet]);

        for (let i = 0; i < elementsSS.length; i++) {
          ids.push(Object.values(elementsSS[i])[4])
        }
      }
      const productsFromExcel = XLSX.utils.sheet_to_json(workbook.Sheets[secondSheet]);


      for (let i = 0; i < productsFromExcel.length; i++) {
        try {
          //console.log(workbook.Sheets[secondSheet]["D"+ (i+2)].l.Target)
          let id = workbook.Sheets[secondSheet]["D" + (i + 2)].l.Target.split('/card/')[1];

          products.push(id)
        } catch (e) {
          console.log(e)
        }
      }

      const servicesFromExcel = XLSX.utils.sheet_to_json(workbook.Sheets[thirdSheet]);

      for (let i = 0; i < servicesFromExcel.length; i++) {
        try {
          //console.log(workbook.Sheets[secondSheet]["D"+ (i+2)].l.Target)
          let code = workbook.Sheets[thirdSheet]["A" + (i + 2)].l.Target.split('/cloud/')[1].replace('/overview', '');
          services.push(code)
        } catch (e) {
          console.log(e)
        }
      }

      response = await axios.post(`${serverAPI}/excel2cart`, { ids, products, services });

      if (response && response.data) {
        // Обработка ответа от БД
        const { data } = response;
        if (data && (data.apps && data.apps.length > 0 || data.products && data.products.length > 0 || data.services && data.services.length > 0)) {
          AddToCard(response.data)
        } else {
          setIsReading(false);
          setErrorMessage(translate.Words[`NotParseExcelCompl_${lang}`]);
        }
      } else { }
    };
    reader.readAsArrayBuffer(file);
  }, []);

  function uniqueArr(arr) {
    let result = [];

    for (let str of arr) {
      if (!result.includes(str)) {
        result.push(str);
      }
    }

    return result;
  }

  function AddToCard({ apps, products, services }) {
    const CardData = JSON.parse(localStorage.getItem('cartApp')) || [];
    let unique = uniqueArr(CardData.concat(apps))
    localStorage.setItem('cartApp', JSON.stringify(unique));
    let cartProd = JSON.parse(localStorage.getItem('cartProd')) || [];
    unique = uniqueArr(cartProd.concat(products));
    localStorage.setItem('cartProd', JSON.stringify(unique));
    let cartCloud = JSON.parse(localStorage.getItem('cartCloud')) || [];
    unique = uniqueArr(cartCloud.concat(services));
    localStorage.setItem('cartCloud', JSON.stringify(unique));


    window.location.reload();
  }

  function handleFiles(files) {
    for (let i = 0; i < files.length; i++) {
      if (validateFile(files[i])) {
        // add to an array so we can display the name of file
        // setIsReading(true);
        // readFile(files[0])
        setSelectedFiles(prevArray => [files[i]]);
      } else {
        // add a new property called invalid
        files[i]['invalid'] = true;
        // add to the same array so we can display the name of the file
        setSelectedFiles(prevArray => [files[i]]);
        // set error message
        setErrorMessage(translate.Words[`Uploaded${lang}`]);
        setUnsupportedFiles(prevArray => [files[i]]);
      }
    }
  }

  function dragLeave(e) {
    e.preventDefault();
  }

  function fileDrop(e) {
    setUnsupportedFiles([])
    setErrorMessage('');
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  }

  function validateFile(file) {
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }
    return true;
  }

  function removeFile() {
    setValidFiles([]);
    setSelectedFiles([]);
    setUnsupportedFiles([]);
    fileInputRef.current.value = ""
  }

  function fileInputClicked() {
    if (errorMessage) {
      removeFile()
      setErrorMessage('');
    }
    fileInputRef.current.click();
  }

  function filesSelected() {
    if (fileInputRef.current.files.length) {
      setUnsupportedFiles([]);
      handleFiles(fileInputRef.current.files);
    }
  }

  function uploadFiles() {
    for (let i = 0; i < validFiles.length; i++) {
      setIsReading(true);
      handleFileChange(validFiles[i])
    }
  }

  useEffect(() => {
    if (window.innerWidth < 380) {
      _mobileView(true)
    }
  }, [window.innerWidth]);

  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 2,
      borderRadius: 20
    },
    colorPrimary: {
      backgroundColor: "#BCBBD0"
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#81D39D"
    }
  }))(LinearProgress);

  let MIN = 0;
  let MAX = 4;
  let value = 3;

  return (
    <Grid container direction="column" justify="flex-start" alignItems="flex-start" className={classes.container}>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="flex-start"
        style={{ maxWidth: 472, marginBottom: 30 }}
      >
        <Grid item>
          <Typography component='h2' className={classes.DesktopTitle2}>{translate.Words[`AddPackage${lang}`]} <br /> {translate.Words[`From1${lang}`]}   Excel</Typography>
        </Grid>

        <Grid item style={{ marginTop: 16 }}>
          <Typography component='p' className={classes.DesktopBody1}>{translate.Words[`DromZoneText${lang}`]}   </Typography>
        </Grid>
      </Grid>

      <CardActionArea onClick={fileInputClicked} style={{ borderRadius: '16px', zIndex: 55 }}>
        <Grid container className={classes.dropContainer} onDragOver={(e) => dragOver(e)} onDragEnter={(e) => dragEnter(e)} onDragLeave={(e) => dragLeave(e)} onDrop={(e) => fileDrop(e)}>
          <Grid container style={{ padding: '32px 20px 0 20px', cursor: 'pointer' }}>
            <Grid item container direction="column" justify="flex-start" alignItems="center" className={classes.DropMessage}>
              <input
                ref={fileInputRef}
                className={classes.FileInput}
                type="file"
                accept=".xlsx"
                // multiple
                onChange={filesSelected}
              />

              <Grid item className={classes.UploadIcon}>
                <AddCompleteSetIcon fill={'#BCBBD0'} />
              </Grid>

              <Grid item style={{ marginTop: 27 }}>
                {
                  lang === 'Ru'
                    ?
                    <Typography component='p' className={classes.DesktopBody1}>Перетащите сюда документ или </Typography>
                    :
                    <Typography component='p' className={classes.DesktopBody1}>Drag and drop a document here </Typography>
                }
              </Grid>

              <Grid item>
                {
                  lang === 'Ru'
                    ?
                    <Typography component='p' className={classes.DesktopBody1}>выберите файл на вашем компьютере</Typography>
                    :
                    <Typography component='p' className={classes.DesktopBody1}>or select a file on your computer</Typography>
                }
              </Grid>
            </Grid>

            {/* {isReading === true ?
              <Grid container
                direction="column"
                justify="flex-start"
                alignItems="center" style={{ marginTop: 24 }}>
                <Grid item className={classes.progress} style={{ width: '100%' }}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={((value - MIN) * 100) / (MAX - MIN)}
                  />
                </Grid>

                <Typography component='p' className={classes.DesktopBody1} style={{ marginTop: 16 }}>Загрузка ...</Typography>
              </Grid>
              :
              <></>
            } */}

            <Grid item container>
              {
                validFiles.map((data, i) =>
                  <React.Fragment>
                    {!(data.invalid || errorMessage) && isReading === false ?
                      <Paper className={classes.FileStatusBar} key={i} onClick={(e) => e.stopPropagation()} style={{ marginTop: 24, padding: '24px 16px', boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)' }}>
                        <Grid
                          item
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                        >
                          <div><DoneIcon /></div>
                          <span className={classes.FileName}>{data.name}</span>
                          <div className={classes.FileRemove} onClick={() => removeFile(data.name)}><CloseIcon fill={'#8987A2'} /></div>
                        </Grid>
                      </Paper>
                      :
                      data.invalid || errorMessage ?
                        (data.invalid || errorMessage) && <Grid container direction="column" justify="flex-start" alignItems="center" style={{ marginTop: 24 }}><Grid item style={{ maxWidth: 272, textAlign: 'center' }}><span className={classes.FileErrorMessage}>{errorMessage}</span></Grid></Grid>
                        :
                        isReading === true ?
                          <Grid container
                            direction="column"
                            justify="flex-start"
                            alignItems="center" style={{ marginTop: 24, marginBottom: 20, height: 72 }}
                          >
                            <Grid item container style={{ width: '100%', height: 42 }}>
                              <Grid item className={classes.progress} style={{ width: '100%' }}>
                                <BorderLinearProgress
                                  variant="determinate"
                                  value={((value - MIN) * 100) / (MAX - MIN)}
                                />
                              </Grid>

                              <Typography component='p' className={classes.DesktopBody1} style={{ marginTop: 16, textAlign: 'center', width: '100%' }}>
                                {translate.Words[`Loading${lang}`]}...</Typography>
                            </Grid>
                          </Grid>
                          :
                          ''
                    }
                  </React.Fragment>
                )
              }
            </Grid>
          </Grid>

          <Grid item container direction='row' style={{ padding: '4px 20px 32px', maxWidth: 376, /* maxHeight: 91 */ }}>
            {unsupportedFiles.length === 0 && validFiles.length && !errorMessage ?
              <Grid item container direction="row" justify={mobileView ? "center" : "space-between"} alignItems="center" onClick={(e) => e.stopPropagation()} style={{ zIndex: 88 }}>
                <SecondaryButton height={55} text={translate.Words[`Cancel${lang}`]} onClick={() => removeFile()} width={mobileView ? '153px' : 'unset'} />
                {mobileView
                  ?
                  <div style={{ height: '24px', width: '100%' }}></div>
                  :
                  null
                }
                <PrimaryButton height={55} text={translate.Words[`Attach${lang}`]} onClick={() => uploadFiles()} width={mobileView ? '153px' : 'unset'} />
              </Grid>
              : ''}
          </Grid>
        </Grid>
      </CardActionArea>
    </Grid >
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    // transform: 'translateY(-100 %)',
    padding: '80px 64px',

    [theme.breakpoints.down(696)]: {
      padding: '56px 24px',
    }

    // '& p': {
    //   fontFamily: 'Cera CY',
    //   fontStyle: 'normal',
    //   fontWeight: 'normal',
    //   fontSize: '16px',
    //   lineHeight: '24px',
    //   textAlign: 'center',
    //   color: '#8987A2',
    // }
  },

  dropContainer: {
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    maxWidth: 472,
    // height: 521,
    border: '1px dashed #BCBBD0',
    borderRadius: '16px'
  },

  DesktopBody1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
  },

  DesktopTitle2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: '#24262A',
  },

  DropMessage: {
    textAlign: 'center',
    color: '#4aa1f3',
    fontFamily: 'Arial',
    fontSize: '20px',
    width: '100%'
  },

  UploadIcon: {
    width: 36,
    height: 45,
    // background: '../../icons/AddCompleteSetIcon.js',
    backgroundSize: '100%',
    textAlign: 'center',
    margin: '0 auto',
  },

  FileStatusBar: {
    width: '100%',
    verticalAlign: 'top',
    marginTop: 10,
    marginBottom: 20,
    position: 'relative',
    lineHeight: '24px',

    '& div': {
      overflow: 'hidden',
    }
  },

  FileName: {
    // width: 296,
    width: 'calc(100% - 56px)',
    color: '#24262A',
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  FileError: {
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: 50,
    color: '#9aa9bb',
  },

  FileErrorMessage: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#EB505E',
  },

  FileRemove: {
    lineHeight: '15px',
    cursor: 'pointer',
    color: 'red',
  },

  FileInput: {
    display: 'none'
  },

  error: {
    color: 'red',
  },

  progress: {
    flexGrow: 1,
    width: '100%'
  }
}));
